import { BLACKOUT_SCOPES } from "helpers/blackouts"

// Scope names, tag copy and date/time formats are shared with the Calendar blackout surfaces
// and live in `helpers/blackouts`. Re-exported here so this page keeps one import surface.
export {
  BLACKOUT_SCOPES,
  SCOPE_TAG,
  DATE_DISPLAY_FORMAT,
  DATE_DISPLAY_FORMAT_WITH_YEAR,
  DATE_VALUE_FORMAT,
  TIME_DISPLAY_FORMAT,
  TIME_VALUE_FORMAT
} from "helpers/blackouts"

/** Sub-tabs inside the Resources Blackout card. */
export const RESOURCE_TABS = [
  { key: BLACKOUT_SCOPES.CREW, labelKey: "settings.blackout.tab_crew", labelDefault: "Crew" },
  { key: BLACKOUT_SCOPES.EQUIPMENT, labelKey: "settings.blackout.tab_equipment", labelDefault: "Equipment" }
]

/** Scope -> modal title and target-picker copy. */
export const SCOPE_COPY = {
  [BLACKOUT_SCOPES.BUSINESS]: {
    titleKey: "settings.blackout.add_business_title",
    titleDefault: "Add Business Blackout"
  },
  [BLACKOUT_SCOPES.LISTING]: {
    titleKey: "settings.blackout.add_listing_title",
    titleDefault: "Add Listing Blackout",
    targetLabelKey: "settings.blackout.select_listings",
    targetLabelDefault: "Select Listings"
  },
  [BLACKOUT_SCOPES.CREW]: {
    titleKey: "settings.blackout.add_crew_title",
    titleDefault: "Add Crew Blackout",
    targetLabelKey: "settings.blackout.select_crew",
    targetLabelDefault: "Select Crew Members"
  },
  [BLACKOUT_SCOPES.EQUIPMENT]: {
    titleKey: "settings.blackout.add_equipment_title",
    titleDefault: "Add Equipment Blackout",
    targetLabelKey: "settings.blackout.select_equipment",
    targetLabelDefault: "Select Equipment"
  }
}

/** Scopes whose picker offers a leading "All" row. */
export const SCOPES_WITH_ALL_OPTION = [BLACKOUT_SCOPES.CREW, BLACKOUT_SCOPES.EQUIPMENT]

/** Debounce before re-requesting the impact preview as the user edits the form. */
export const IMPACT_DEBOUNCE_MS = 400

export const ROW_MENU_ACTIONS = { EDIT: "edit", DELETE: "delete" }
